import {
  ArrowDownwardTwoTone,
  ArrowUpwardTwoTone,
  FilterList,
} from "@mui/icons-material";
import { Close_Icon, Search_Icon } from "../../../assets/images";
import { Collapse, Tooltip } from "@mui/material";
import { selectToken, selectUser } from "../../../features/auth/authSlice";
import {
  useCreateProviderMutation,
  useDeleteProviderMutation,
  useUpdateProviderMissingFieldsMutation,
} from "../../../features/provider/providerApiSlice";
import {
  useCreateProviderUserMutation,
  useResendInviteMutation,
  useUpdateUserEmailAndPhoneMutation,
} from "../../../features/user/userApiSlice";

import CheckboxSelector from "../../Schedules/components/CheckboxSelector";
import CloseSvg from "../../../assets/svgs/CloseSvg";
import { FileUploader } from "react-drag-drop-files";
import FilterSelect from "../../../components/Filter/FilterSelect";
import IconComponent from "../../../components/DataTable/Icon";
import { Icons } from "../../../assets";
import Loading from "../../../components/Loading";
import ProviderUpdateModal from "./components/ProviderUpdateModal";
import React from "react";
import ReusableModal from "../../../components/Modals/ReusableModal";
import Search from "../../../components/Search/SearchNew";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import axios from "axios";
import classNames from "classnames";
import {
  useGetProvidersMutation,
  useGetProviderFiltersMutation,
} from "../../../features/organisation/organisationApiSlice";
import { useLSStore } from "../../../context/ls-store";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  ACTIVITY_STATUS,
  ACTIVITY_TYPE,
} from "../../../constants/config.constants";
import { useCreateLogsMutation } from "../../../features/logs/logsApiSlice";
import ProviderZoneEditModal from "./components/ProviderZoneEditModal";
import Pagination from "../../../components/Pagination/Pagination";
import ProviderAddModal from "./components/ProviderAddModal";
import useDebounce from "../../../hooks/useDebounce";

const fileTypes = ["csv", "xls", "xlsx"];

const ProviderList = () => {
  const [providers, setProviders] = React.useState([]);
  const [statuses, setStatuses] = React.useState([]);
  const [specialities, setSpecialities] = React.useState([]);
  const [types, setTypes] = React.useState([]);
  const [zones, setZones] = React.useState([]);
  const [zips, setZips] = React.useState([]);

  const [specialityFilter, setSpecialityFilter] = React.useState([]);
  const [typeFilter, setTypeFilter] = React.useState([]);
  const [statusFilter, setStatusFilter] = React.useState(["ACTIVE"]);
  const [searchFilter, setSearchFilter] = React.useState("");
  const [count, setCount] = React.useState(0);

  const [inviteModal, setInviteModal] = React.useState(false);
  const [selectedProvider, setSelectedProvider] = React.useState(null);
  // const [sortStatusOrder, setSortStatusOrder] = React.useState("none");
  // const [sortNameOrder, setSortNameOrder] = React.useState("none");
  // const [sortSpecialityOrder, setSortSpecialityOrder] = React.useState("none");

  const [addOpen, setAddOpen] = React.useState(false);
  const [edit, setEdit] = React.useState(null);
  const [zoneEditModalOpen, setZoneEditModalOpen] = React.useState(false);
  const [del, setDel] = React.useState(null);

  const [firstName, setFirstName] = React.useState("");
  const [zoneFilter, setZoneFilter] = React.useState([]);
  const [zipFilter, setZipFilter] = React.useState([]);
  const [sortBy, setSortBy] = React.useState("firstname");
  const [sortOrder, setSortOrder] = React.useState("asc");
  const [showZipModal, setShowZipModal] = React.useState({ status: false, zips: [] });


  const navigate = useNavigate();
  const searchDebounce = useDebounce(searchFilter, 500);

  // const handleSortStatus = (a, b) => {
  //   if (sortStatusOrder === "none") {
  //     return 0;
  //   } else if (sortStatusOrder === "asc") {
  //     return a.status.localeCompare(b.status);
  //   } else {
  //     return b.status.localeCompare(a.status);
  //   }
  // };

  // const handleSortName = (a, b) => {
  //   if (sortNameOrder === "none") {
  //     return 0;
  //   } else if (sortNameOrder === "asc") {
  //     return a.name.localeCompare(b.name);
  //   } else {
  //     return b.name.localeCompare(a.name);
  //   }
  // };

  // const handleSortSpeciality = (a, b) => {
  //   if (sortSpecialityOrder === "none") {
  //     return 0;
  //   } else if (sortSpecialityOrder === "asc") {
  //     return a.speciality.localeCompare(b.speciality);
  //   } else {
  //     return b.speciality.localeCompare(a.speciality);
  //   }
  // };

  const handleSpecialityFilter = (speciality) => {
    if (specialityFilter.indexOf(speciality) === -1) {
      setSpecialityFilter([...specialityFilter, speciality]);
    } else {
      setSpecialityFilter(
        specialityFilter.filter((filter) => filter !== speciality)
      );
    }
  };

  const handleTypeFilter = (type) => {
    if (typeFilter.indexOf(type) === -1) {
      setTypeFilter([...typeFilter, type]);
    } else {
      setTypeFilter(typeFilter.filter((filter) => filter !== type));
    }
  };

  const handleStatusFilter = (status) => {
    if (statusFilter.indexOf(status) === -1) {
      setStatusFilter([...statusFilter, status]);
    } else {
      setStatusFilter(statusFilter.filter((filter) => filter !== status));
    }
  };

  const handleZoneFilter = (zip) => {
    // if (zoneFilter.indexOf(zone) === -1) {
    //   setZoneFilter([...zoneFilter, zone]);
    // } else {
    //   setZoneFilter(zoneFilter.filter((filter) => filter !== zone));
    // }

    if (zipFilter.indexOf(zip) === -1) {
      // setZoneFilter([...zoneFilter, zone]);
      setZipFilter([...zipFilter, zip])
    } else {
      // setZoneFilter(zoneFilter.filter((filter) => filter !== zone));
      setZipFilter(zipFilter.filter((filter) => filter != zip))
    }
  };

  const handleProviderClick = (provider) => {
    let url = `/data-management/providers/${provider.id}`;
    if (provider.provider_market_id) {
      url += `?market=${provider.provider_market_id}`;
    }

    navigate(url);
  };

  const user = useSelector(selectUser);
  const [getProviders, { isLoading: providerLoading }] =
    useGetProvidersMutation();
  const [getProviderFilters, { isLoading: providerFiltersLoading }] =
    useGetProviderFiltersMutation();

  const [createProviderUser, { isLoading: userLoading }] =
    useCreateProviderUserMutation();
  const [updateProviderMissingFields, { isLoading: missingLoading }] =
    useUpdateProviderMissingFieldsMutation();

  const [deleteProvider, { isLoading: deleteLoading }] =
    useDeleteProviderMutation();

  const [updateUserApi, { isLoading: updateLoading }] =
    useUpdateUserEmailAndPhoneMutation();

  const [createLog] = useCreateLogsMutation();
  const [resendInvite, { isLoading: resendLoading }] =
    useResendInviteMutation();

  const isLoading =
    providerLoading ||
    userLoading ||
    missingLoading ||
    deleteLoading ||
    updateLoading ||
    resendLoading;

  const updateMissingFields = async (data) => {
    try {
      const payload = {
        activity: `User ${user?.details?.name} has updated the data for provider ${selectedProvider.name}.`,
        type: ACTIVITY_TYPE.PROVIDER_UPDATE,
        data: {
          providerId: selectedProvider.id,
        },
      };
      try {
        await updateProviderMissingFields({
          id: selectedProvider.id,
          data: {
            npi_id: data.providerNpi,
            speciality: data.providerSpeciality,
            street: data.providerStreet,
            city: data.providerCity,
            state: data.providerState,
            zip: data.providerZip,
            market_id: data.market_id,
          },
        }).unwrap();

        const updatedProviders = providers.map((provider) => {
          if (provider.id === selectedProvider.id) {
            return {
              ...provider,
              npi_id: +data.providerNpi,
              speciality: data.providerSpeciality,
              address: [
                data.providerStreet,
                data.providerCity,
                data.providerState,
                data.providerZip,
              ],
            };
          }
          return provider;
        });

        setProviders(updatedProviders);

        setAlert({
          message: "Provider Updated Successfully",
          severity: "success",
        });
        await createLog({
          ...payload,
          status: ACTIVITY_STATUS.SUCCESS,
        }).unwrap();
      } catch (error) {
        await createLog({
          ...payload,
          status: ACTIVITY_STATUS.FAILED,
        }).unwrap();
        throw new Error(error.data?.message || error.message);
      }
    } catch (error) {
      throw new Error(error.message);
    }
  };

  const inviteProvider = async (data) => {
    try {
      const payload = {
        activity: `User ${user?.details?.name} has invited provider ${selectedProvider.name} to join CareSMS`,
        type: ACTIVITY_TYPE.PROVIDER_UPDATE,
        data: {
          providerId: selectedProvider.id,
        },
      };
      try {
        await createProviderUser({
          providerId: selectedProvider.id,
          userData: {
            type: 3,
            email: data.providerEmail,
            phone: data.providerPhone,
          },
        }).unwrap();

        const updatedProviders = providers.map((provider) => {
          if (provider.id === selectedProvider.id) {
            return {
              ...provider,
              email: data.providerEmail,
              phone: data.providerPhone,
            };
          }
          return provider;
        });

        setProviders(updatedProviders);

        setAlert({
          message: "Provider Invited Successfully",
          severity: "success",
        });
        await createLog({
          ...payload,
          status: ACTIVITY_STATUS.SUCCESS,
        }).unwrap();
      } catch (error) {
        await createLog({
          ...payload,
          status: ACTIVITY_STATUS.FAILED,
        }).unwrap();
        throw new Error(error.data.message || error.message);
      }
    } catch (error) {
      throw new Error(error.message);
    }
  };

  const handleResendInvite = async (data) => {
    try {
      const payload = {
        activity: `User ${user?.details?.name} has resent the invite for provider ${data.name}`,
        type: ACTIVITY_TYPE.PROVIDER_UPDATE,
        data: {
          providerId: selectedProvider.id,
        },
      };
      try {
        await resendInvite({
          id: data.userId,
          email: data.email,
          firstname: data.name.split(" ")[0],
        }).unwrap();

        setAlert({
          message: "Provider Invite sent Successfully",
          severity: "success",
        });
        await createLog({
          ...payload,
          status: ACTIVITY_STATUS.SUCCESS,
        }).unwrap();
      } catch (error) {
        await createLog({
          ...payload,
          status: ACTIVITY_STATUS.FAILED,
        }).unwrap();
        throw new Error(error.data.message || error.message);
      }
    } catch (error) {
      throw new Error(error.message);
    }
  };

  const updateContactDetails = async (data) => {
    try {
      const payload = {
        activity: `User ${user?.details?.name} has updated the data for provider ${selectedProvider.name}.`,
        type: ACTIVITY_TYPE.PROVIDER_UPDATE,
        data: {
          providerId: selectedProvider.id,
        },
      };
      try {
        await updateUserApi({
          id: selectedProvider.id,
          type: 3,
          phone: data.providerPhone,
          email: data.providerEmail,
        }).unwrap();

        const updatedProviders = providers.map((provider) => {
          if (provider.id === selectedProvider.id) {
            return {
              ...provider,
              email: data.providerEmail,
              phone: data.providerPhone,
            };
          }
          return provider;
        });

        setProviders(updatedProviders);

        setAlert({
          message: "Contact Details Updated Successfully",
          severity: "success",
        });
        await createLog({
          ...payload,
          status: ACTIVITY_STATUS.SUCCESS,
        }).unwrap();
      } catch (error) {
        await createLog({
          ...payload,
          status: ACTIVITY_STATUS.FAILED,
        }).unwrap();
        throw new Error(error.data?.message || error.message);
      }
    } catch (error) {
      throw new Error(error.message);
    }
  };

  const fetchProviders = async ({
    limit,
    skip,
    search,
    status,
    zones,
    specialities,
    types,
    sortBy,
    sortOrder,
    zips
  }) => {
    try {
      const payload = {
        orgId: user.organisation.id,
        limit,
        skip,
        search,
        status,
        zones,
        specialities,
        types,
        zips,
        showZones: true,
        showConstraints: false,
        showLeaves: false,
        showZipCodes: true
      };

      if (sortBy && sortOrder) {
        payload["sortBy"] = sortBy;
        payload["sortOrder"] = sortOrder;
      }

      const { data, count } = await getProviders(payload).unwrap();
      setProviders(data ?? []);
      setCount(count);
    } catch (error) {
      setCount(0);
      setProviders([]);
      console.error(error.data.message);
    }
  };

  const handleSelectProvider = (provider) => {
    setSelectedProvider(provider);
    setZoneEditModalOpen(true);
  };

  const updateProviderZones = (locationId, zones) => {
    const updatedProviders = providers.map((provider) => {
      if (provider.locationId === locationId) {
        return { ...provider, zones };
      }
      return provider;
    });

    setProviders(updatedProviders);
  };

  const fetchProviderFilters = async () => {
    const { data } = await getProviderFilters({
      orgId: user.organisation.id,
    }).unwrap();
    setSpecialities(data.specialities ?? []);
    setTypes(data.types ?? []);
    setStatuses(data.statuses ?? []);
    setZones(data.zones ?? []);
    setZips(data?.zips ?? []);
  };

  React.useEffect(() => {
    fetchProviderFilters();
  }, []);

  React.useEffect(() => {
    fetchProviders({
      limit: 20,
      skip: 0,
      search: searchDebounce,
      status: statusFilter,
      zones: zoneFilter,
      zips: zipFilter,
      specialities: specialityFilter,
      types: typeFilter,
      sortBy,
      sortOrder,
    });
  }, [
    searchDebounce,
    statusFilter,
    zoneFilter,
    specialityFilter,
    typeFilter,
    sortBy,
    sortOrder,
    zipFilter
  ]);

  const Avatar = ({ name, image }) => {
    return (
      <>
        {image !== null ? (
          <div className="flex items-center gap-2">
            <img
              src={image}
              alt={name}
              className="object-cover w-10 h-10 rounded-full"
            />
            <p className="m-0 font-semibold">{name}</p>
          </div>
        ) : (
          <p className="flex items-center justify-center w-10 h-10 m-0 text-white rounded-full bg-primaryblue">
            {name
              .split(" ")
              .map((n) => n[0])
              .join("")}
          </p>
        )}
      </>
    );
  };

  const setAlert = useLSStore((state) => state.setAlert);
  const token = useSelector(selectToken);

  async function uploadFile(file) {
    const formData = new FormData();
    formData.append("file", file);

    const payload = {
      activity: `User ${user?.details?.name} has uploaded provider data.`,
      type: ACTIVITY_TYPE.PROVIDER_UPLOAD,
      data: {
        providerId: selectedProvider.id,
      },
    };

    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/provider/verify-provider-doc`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": process.env.REACT_APP_SERVER_URL,
          },
          withCredentials: true,
        }
      );

      await fetchProviders({});

      setOpenDropdown(false);

      setAlert({
        message: "Data Uploaded Successfully",
        severity: "success",
      });
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.SUCCESS,
      }).unwrap();
    } catch (error) {
      console.log(error);
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.FAILED,
      }).unwrap();
    }
  }

  const handleChange = (file) => {
    try {
      uploadFile(file);
    } catch (error) {
      console.log("err");
    }
  };

  const [openDropdown, setOpenDropdown] = React.useState(false);

  const onDeleteProvider = async () => {
    const payload = {
      activity: `Provider ${firstName} has been deleted by the User - ${user?.details?.name}`,
      type: ACTIVITY_TYPE.PROVIDER_DELETE,
      data: {
        providerId: del,
      },
    };
    try {
      await deleteProvider({
        id: del,
      }).unwrap();
      setProviders((prev) => {
        const update = [...prev];
        const index = update.findIndex((x) => x.id === del);
        update[index] = { ...update[index], status: "INACTIVE" };
        return [...update];
      });
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.SUCCESS,
      }).unwrap();
    } catch (error) {
      console.error(error?.data?.message);
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.FAILED,
      }).unwrap();
    }
  };

  const onEdit = (provider) => {
    setInviteModal(true);
    setEdit(provider.id);
    setSelectedProvider(provider);
  };

  const onDelete = (provider) => {
    setFirstName(provider.name);
    setDel(provider.id);
  };

  const clearInput = () => { };

  const downloadCSV = async () => {
    const payload = {
      activity: `User ${user?.details?.name} has downloaded provider upload template`,
      type: ACTIVITY_TYPE.PROVIDER_UPLOAD,
      data: {
        providerId: selectedProvider.id,
      },
    };
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/provider/get/template`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "provider-template.csv");
      document.body.appendChild(link);
      link.click();
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.SUCCESS,
      }).unwrap();
    } catch (error) {
      console.error(error);
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.FAILED,
      }).unwrap();
    }
  };

  return (
    // <div className="flex flex-col items-start py-4 overflow-hidden h-[calc(100vh-100px)]">
    <div className="flex flex-col items-start items-center justify-center py-4 overflow-hidden h-[calc(100vh-100px)]">
      <div className="flex-shrink-0 items-center w-full">
        <Loading loading={isLoading} />
        {/* {user?.permissions?.includes('providers_dm.upload_providers') && (
          <div
            className={classNames(
              "w-full px-16 transition-all",
              !openDropdown && "pb-3"
            )}
          >
            <button
              onClick={() => {
                setOpenDropdown(!openDropdown);
              }}
              className="flex flex-row items-center justify-between w-full px-4 py-2 bg-gray-100 rounded-md"
            >
              <div className="flex flex-row items-center">
                Upload Provider Data
                <img
                  src={Icons.Upload_Icon}
                  alt="upload icon"
                  className="mx-2 icon"
                />
              </div>
              {openDropdown ? (
                <Tooltip title="Collapse">
                  <ArrowDownwardTwoTone />
                </Tooltip>
              ) : (
                <Tooltip title="Expand">
                  <ArrowUpwardTwoTone />
                </Tooltip>
              )}
            </button>
          </div>
        )} */}
        {user?.permissions?.includes('providers_dm.upload_providers') && <Collapse in={openDropdown} className="w-full">
          <div className="flex flex-col w-full gap-1 px-16 py-8">
            <div className="flex flex-row items-end justify-end w-full mb-2 md:mb-0">
              <p
                className="m-0 text-sm underline text-primaryblue"
                onClick={downloadCSV}
                role="button"
              >
                Provider Data Template
              </p>
            </div>
            <FileUploader
              handleChange={handleChange}
              name="file"
              types={fileTypes}
              classes="w-100"
            >
              <div className="flex hover:bg-subtleblue transition-all cursor-pointer flex-col w-full justify-center items-center gap-2 border-[1px] border-dashed border-secondarygrayborder rounded-lg p-4">
                <img
                  src={Icons.Upload_Icon}
                  alt="upload icon"
                  className="mx-2 icon"
                />
                <p className="m-0 mt-2 text-sm">
                  Drag & Drop or{" "}
                  <span className="text-primaryblue">Choose file</span> to upload
                </p>
              </div>
            </FileUploader>
          </div>
        </Collapse>}
        <div className="flex flex-row items-center justify-between w-full px-16">
          <div className="flex flex-row items-center w-full gap-12">
            <h1 className="m-0 text-2xl font-bold w-fit whitespace-nowrap">
              Providers{" "}
              <span className="ml-2 text-base font-bold text-primaryblue">
                {providers?.length}
                {/* {providers.length} */}
              </span>
            </h1>
            <div className="flex flex-row items-center w-full gap-3">
              {user?.permissions?.includes('providers_dm.search') && <Search value={searchFilter} setValue={setSearchFilter} />}
              {user?.permissions?.includes('providers_dm.filter_speciality') && <FilterSelect
                value={specialityFilter}
                handleChange={handleSpecialityFilter}
                data={specialities}
                placeholder="Filter by Speciality..."
                enableSearch={true}
              />}
              {user?.permissions?.includes('providers_dm.filter_type') && <FilterSelect
                value={typeFilter}
                handleChange={handleTypeFilter}
                data={types}
                placeholder="Filter by Type..."
                enableSearch={true}
              />}
              {user?.permissions?.includes('providers_dm.filter_status') && <FilterSelect
                value={statusFilter}
                handleChange={handleStatusFilter}
                data={statuses}
                placeholder="Filter by Status ..."
              />}
              {user?.permissions?.includes('providers_dm.filter_zip') && <FilterSelect
                // value={zoneFilter}
                value={zipFilter}
                handleChange={handleZoneFilter}
                // data={zones}
                data={zips}
                placeholder="Filter by Zip..."
                enableSearch={true}
              />}
              {user?.permissions?.includes('providers_dm.add_provider') && <button
                // onClick={() => {
                //   setAddOpen(true);
                // }}
                disabled
                className="px-4 py-2 shadow-sm rounded-md border-[2px] border-primarygrayborder whitespace-nowrap text-primaryblue disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Add New
              </button>}
            </div>
          </div>
        </div>
        <div className="px-16">
          <Pagination count={count} api={fetchProviders} />
        </div>
      </div>
      <div className="w-full px-16 flex-1 min-h-0 mt-2">
        {/* <div className="relative w-full mt-1 mb-2 overflow-x-auto overflow-y-auto bg-white rounded-lg shadow max-h-[calc(100vh-295px)]"> */}
        <div className="relative w-full mt-1 mb-2 overflow-x-auto overflow-y-auto bg-white rounded-lg shadow h-full">
          <table className="relative w-full whitespace-no-wrap bg-white border-collapse table-auto table-striped">
            <thead>
              <tr className="h-16 text-base font-bold text-left text-white bg-primaryblue whitespace-nowrap">
                <th className="px-4 py-3">
                  <div className="flex flex-row items-center gap-1">
                    <p className="m-0">Name</p>
                    <button
                      className="flex flex-col items-center gap-1"
                      onClick={() => {
                        if (sortBy == "firstname") {
                          if (!sortOrder) {
                            setSortOrder("asc");
                          }
                          if (sortOrder === "asc") {
                            setSortOrder("desc");
                          }
                          if (sortOrder === "desc") {
                            setSortOrder("");
                          }
                        } else {
                          setSortBy("firstname");
                          setSortOrder("asc");
                        }
                      }}
                    >
                      {sortBy == "firstname" && sortOrder === "asc" ? (
                        <Tooltip title="Sort Descending">
                          <ArrowDownwardTwoTone />
                        </Tooltip>
                      ) : sortBy == "firstname" && sortOrder === "desc" ? (
                        <Tooltip title="Sort Ascending">
                          <ArrowUpwardTwoTone />
                        </Tooltip>
                      ) : (
                        // <div className="flex items-center h-4">
                        //   <div className="w-6 h-[2px] bg-white" />
                        // </div>
                        <div className="flex items-center providerlist-icon">
                          <SwapVertIcon />
                        </div>
                      )}
                    </button>
                  </div>
                </th>
                <th className="px-4 py-3">
                  <div className="flex flex-row items-center gap-2">
                    <p className="m-0">Speciality</p>
                    <button
                      className="flex flex-col items-center gap-1"
                      onClick={() => {
                        if (sortBy == "speciality") {
                          if (!sortOrder) {
                            setSortOrder("asc");
                          }
                          if (sortOrder === "asc") {
                            setSortOrder("desc");
                          }
                          if (sortOrder === "desc") {
                            setSortOrder("");
                          }
                        } else {
                          setSortBy("speciality");
                          setSortOrder("asc");
                        }
                      }}
                    >
                      {sortBy == "speciality" && sortOrder === "asc" ? (
                        <Tooltip title="Sort Descending">
                          <ArrowDownwardTwoTone />
                        </Tooltip>
                      ) : sortBy == "speciality" && sortOrder === "desc" ? (
                        <Tooltip title="Sort Ascending">
                          <ArrowUpwardTwoTone />
                        </Tooltip>
                      ) : (
                        // <div className="flex items-center h-4">
                        //   <div className="w-6 h-[2px] bg-white" />
                        // </div>
                        <div className="flex items-center providerlist-icon">
                          <SwapVertIcon />
                        </div>
                      )}
                    </button>
                  </div>
                </th>
                <th className="px-4 py-3">Type</th>
                <th className="px-4 py-3">NPI ID</th>
                <th className="px-4 py-3">Phone</th>
                <th className="px-4 py-3">Email</th>
                {process.env.REACT_APP_ENV === "dev" && (
                  <th className="px-4 py-3">Coverage</th>
                )}
                <th className="px-4 py-3">
                  <div className="flex flex-row items-center gap-2">
                    <p className="m-0">Status</p>
                    <button
                      className="flex flex-col items-center gap-1"
                      onClick={() => {
                        if (sortBy == "status") {
                          if (!sortOrder) {
                            setSortOrder("asc");
                          }
                          if (sortOrder === "asc") {
                            setSortOrder("desc");
                          }
                          if (sortOrder === "desc") {
                            setSortOrder("");
                          }
                        } else {
                          setSortBy("status");
                          setSortOrder("asc");
                        }
                      }}
                    >
                      {sortBy == "status" && sortOrder === "asc" ? (
                        <Tooltip title="Sort Descending">
                          <ArrowDownwardTwoTone />
                        </Tooltip>
                      ) : sortBy == "status" && sortOrder === "desc" ? (
                        <Tooltip title="Sort Ascending">
                          <ArrowUpwardTwoTone />
                        </Tooltip>
                      ) : (
                        <div className="flex items-center providerlist-icon">
                          <SwapVertIcon />
                        </div>
                      )}
                    </button>
                  </div>
                </th>
                {/* <th className="px-4 py-3">Edit</th> */}
                <th className="px-4 py-3">
                  <p className="m-0">Edit</p>
                </th>
                <th className="px-4 py-3">
                  <p className="m-0">Delete</p>
                </th>
              </tr>
            </thead>
            <tbody>
              {providers.length === 0 ? (
                <tr>
                  <td
                    colSpan={process.env.REACT_APP_ENV === "dev" ? 9 : 8}
                    className="py-6 text-lg text-center text-gray-400"
                  >
                    {/* Optionally, you can add an icon here, e.g., <Icons.Empty_Icon className="w-10 h-10 mx-auto mb-2" /> */}
                    No records found
                  </td>
                </tr>
              ) : (
                [...providers]?.map((provider, index) => (
                  <tr
                    className={classNames(
                      "text-left text-gray-900 h-24 whitespace-nowrap",
                      index !== providers?.length - 1
                        ? "border-b"
                        : "border-none"
                    )}
                    key={index}
                  >
                    <td className="px-4 py-3 text-left">
                      <div className="flex flex-row items-center gap-4">
                        <button
                          onClick={() => user?.permissions?.includes('providers_dm.view_specific_provider') && handleProviderClick(provider)}
                          className="flex flex-row items-center gap-4"
                        >
                          <Avatar
                            // name={provider.name ?? ""}
                            name={provider?.name?.replace(/\s*\(.*?\)\s*/g, '') ?? ""}
                            image={provider.profileImage}
                          />
                          <p className="m-0 font-semibold underline">
                            {provider.name}
                          </p>
                        </button>
                        {provider.locationId === null ? (
                          <button
                            onClick={() => {
                              setInviteModal(true);
                              setSelectedProvider(provider);
                            }}
                            className="bg-yellow-50 gap-1 text-yellow-600 border-[1px] flex items-center justify-center border-primaryyellow rounded-md px-2"
                          >
                            <WarningRoundedIcon
                              style={{
                                fontSize: "16px",
                              }}
                            />
                            <p className="m-0 text-sm">Missing Data Points</p>
                          </button>
                        ) : 
                        // (provider.email === "NA" ||
                        //   provider.phone === "NA") && user?.permissions?.includes('providers_dm.invite_provider_to_caresms') ? (
                        //   <button
                        //     onClick={() => {
                        //       setEdit(null);
                        //       setInviteModal(true);
                        //       setSelectedProvider(provider);
                        //     }}
                        //     className="bg-subtleblue border-[1px] border-primaryblue rounded-md px-2"
                        //   >
                        //     <p className="m-0 text-sm text-primaryblue">
                        //       Invite to{" "}
                        //       <span className="font-semibold">CareSMS</span>
                        //     </p>
                        //   </button>
                        // ) 
                        // : 
                        (
                          <button
                            onClick={() => {
                              setEdit(null);
                              setInviteModal(true);
                              setSelectedProvider(provider);
                            }}
                            className="bg-subtleblue border-[1px] border-primaryblue rounded-md px-2"
                          >
                            <p className="m-0 text-sm font-semibold text-primaryblue">
                              Update Contact Details
                            </p>
                          </button>
                        )}
                      </div>
                    </td>
                    <td className="px-4 py-3 text-left text-gray-700">
                      {provider.speciality}
                    </td>
                    <td className="px-4 py-3 text-left text-gray-700">
                      {provider.type}
                    </td>
                    <td className="px-4 py-3 text-left text-gray-700">
                      {provider.npi_id}
                    </td>
                    <td className="px-4 py-3 text-left text-gray-700">
                      {provider.phone}
                    </td>
                    <td className="px-4 py-3 text-left text-gray-700">
                      {provider.email}
                    </td>
                    {process.env.REACT_APP_ENV === "dev" && (
                      <td className="gap-2 px-4 py-3 text-left text-gray-700">
                        {/* {provider.locationName === null
                          ? "Private Residence"
                          : provider.zones.length > 0
                            ? `Default, ${provider.zones.length > 2
                              ? `${provider.zones
                                .slice(0, 2)
                                .map((zone) => zone.name)
                                .join(", ")} +${provider.zones.length - 2
                              } more`
                              : provider.zones
                                .map((zone) => zone.name)
                                .join(", ")
                            }`
                            : "Default"} */}
                        {/* {
                          provider.zip_codes.length > 0
                            ? provider.zip_codes
                              .map((zip) => zip)
                              .join(", ") : ""
                        } */}
                        <span
                          onClick={() => {
                            if (provider.zip_codes.length > 0) {
                              // setSelectedZipCodes(provider.zip_codes); // store them in state
                              setShowZipModal({ status: true, zips: provider.zip_codes }); // open modal
                            }
                          }}
                          className={`${provider.zip_codes.length > 0
                            ? 'text-primaryblue font-semibold underline cursor-pointer hover:text-blue-700 transition'
                            : 'text-gray-500 cursor-default'
                            }`}
                        >
                          {provider.zip_codes.length}
                        </span>
                        {/* {user?.permissions?.includes('providers_dm.update_provider_zones') && <button className="pt-2 ml-2">
                          <IconComponent
                            tooltip="Edit Zone"
                            icon={"Edit_Icon"}
                            i={provider}
                            onClick={() => {
                              handleSelectProvider(provider);
                            }}
                          />
                        </button>} */}
                      </td>
                    )}
                    <td className="px-4 py-3 text-left text-gray-700">
                      <div
                        className={classNames(
                          provider.status.toUpperCase() === "ACTIVE"
                            ? "bg-subtlegreen border-[1px] border-primarygreen text-primarygreen"
                            : "bg-primarylightgrey border-[1px] border-primarygrayborder text-primarytextgrey",
                          "rounded-md text-center flex flex-row gap-1 items-center px-2 w-fit"
                        )}
                      >
                        <div
                          className={classNames(
                            "w-2 h-2 rounded-full",
                            provider.status.toUpperCase() === "ACTIVE"
                              ? "bg-primarygreen"
                              : "bg-primarytextgrey"
                          )}
                        />
                        {provider.status}
                      </div>
                    </td>
                    <td className="px-4 py-3 text-center text-gray-700">
                      <IconComponent
                        tooltip="Edit provider"
                        icon={"Edit_Icon"}
                        i={provider}
                        onClick={() => onEdit(provider)}
                        disabled={!user?.permissions?.includes('providers_dm.edit_provider')}
                      />
                    </td>
                    <td className="px-4 py-3 text-center text-gray-700">
                      <IconComponent
                        disabled={provider.status === "Inactive" || !user?.permissions?.includes('providers_dm.delete_provider')}
                        tooltip="Delete provider"
                        icon={"Delete_Icon"}
                        i={provider}
                        onClick={() => onDelete(provider)}
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      {selectedProvider && inviteModal && (
        <ProviderUpdateModal
          open={inviteModal}
          setOpen={setInviteModal}
          handleSubmit={
            selectedProvider.locationId === null || !!edit
              ? updateMissingFields
              : selectedProvider.email === "NA"
                ? inviteProvider
                : updateContactDetails
          }
          provider={selectedProvider}
          setProvider={setSelectedProvider}
          type={
            selectedProvider.locationId === null || !!edit
              ? "update"
              : selectedProvider.email === "NA"
                ? "invite"
                : "update details"
          }
          isEdit={!!edit}
        />
      )}
      {addOpen && (
        <ProviderAddModal
          open={addOpen}
          setOpen={setAddOpen}
          fetchProviders={fetchProviders}
        />
      )}
      <ReusableModal
        open={!!del}
        title="Delete provider"
        onClose={() => {
          setDel(null);
          clearInput();
        }}
      >
        <p className="p-3 text-base">
          Are you sure you want to delete provider: {firstName}?
        </p>
        <div className="flex justify-end">
          <div className="flex gap-2 m-3">
            <button
              className="w-28 disabled:opacity-40 disabled:cursor-not-allowed font-semibold p-2 border-[2px] rounded-md bg-subtleblue border-primaryblue text-primaryblue whitespace-nowrap"
              onClick={() => {
                setDel(null);
                clearInput();
              }}
            >
              Cancel
            </button>
            <button
              className="p-2 font-semibold text-white rounded-md w-28 disabled:opacity-40 disabled:cursor-not-allowed bg-primaryblue whitespace-nowrap"
              onClick={async () => {
                await onDeleteProvider();
                clearInput();
                setDel(null);
              }}
            >
              Delete
            </button>
          </div>
        </div>
      </ReusableModal>
      <ReusableModal
        open={showZipModal?.status}
        title="Coverage"
        onClose={() => {
          setShowZipModal({ status: false, zips: [] })
        }}
      >
        <div className="min-w-[45vw] max-w-[45vw] p-3 ">
          <h2 className="text-lg font-semibold mb-3">Zip Codes</h2>
          <div
            className="text-gray-700 max-h-[400px] overflow-y-auto p-2 rounded-md border border-gray-200 bg-gray-50"
          >
            {showZipModal?.zips?.length > 0 ? (
              <p className="whitespace-normal break-words leading-relaxed">
                {showZipModal.zips.join(", ")}

              </p>
            ) : (
              <p className="text-gray-500 italic">No Zip codes available.</p>
            )}
          </div>
        </div>
      </ReusableModal>
      {selectedProvider && (
        <ProviderZoneEditModal
          open={zoneEditModalOpen}
          setOpen={setZoneEditModalOpen}
          provider={selectedProvider}
          updateProviderZones={updateProviderZones}
        />
      )}
    </div>
  );
};

export default ProviderList;
